export default (path) => {
  const match = path.match(/organism\/([a-z0-9]+)$/i);

  return match.length == 2 ? match[1] : undefined;
}